import imgEmpresa from "../../../img/imgEmpresa.jpg";
import { useContext, useState, useRef } from "react";
import { DataContext } from "../../../context/DataContext.jsx";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import { petitions } from "../../../api/calls.js";

export default function SettingsEmpresa() {
  const { session, empresa, saveEmpresa } = useContext(DataContext);
  const [previewImg, setPreviewImg] = useState(imgEmpresa);
  const fileInputRef = useRef(null);

  // ...existing code...

  // Nueva función para manejar el cambio de imagen
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPreviewImg(ev.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const form1 = useForm({
    defaultValues: {
      idEmpresa: empresa?.idEmpresa || "",
      ruc: empresa?.ruc || "",
      rSocial: empresa?.rSocial || "",
      direccion: empresa?.direccion || "",
      telefono1: empresa?.telefono1 || "",
      telefono2: empresa?.telefono2 || "",
      correo: empresa?.correo || "",
      web: empresa?.web || "",
      pais: empresa?.pais || "",
      departamento: empresa?.departamento || "",
      provincia: empresa?.provincia || "",
      distrito: empresa?.distrito || "",
      bloqueo: empresa?.bloqueo || "N",
      validarAlmacen: (empresa?.validarAlmacen ?? "") === "S" ? true : false,
      nombreComercial: empresa?.nombreComercial || "",
      obs: empresa?.obs || "",
    },
  });

  const getRucSunat = async () => {
    const ruc = form1.getValues("ruc");
    if (ruc.length !== 11) {
      toast.warning("El RUC debe tener 11 dígitos");
      return;
    }

    const response = await petitions.getRuc(ruc, session().token);
    if (response.data?.ruc !== undefined) {
      form1.setValue("rSocial", `${response.data.razonSocial}`, {
        shouldValidate: true,
      });
      form1.setValue("direccion", `${response.data.direccion}`, {
        shouldValidate: true,
      });
      return;
    } else {
      toast.warning("RUC con el numero " + ruc + " no encontrado");
      return;
    }
  };

  const sendUpdateEmpresa = form1.handleSubmit(async (data) => {
    data.validarAlmacen = data.validarAlmacen ? "S" : "N";
    data.logo =
      previewImg !== imgEmpresa
        ? previewImg.split(",")[1]
        : empresa?.logo && empresa.logo !== ""
        ? empresa.logo
        : "";

    const response = await petitions.updateEmpresa(session().token, data);

    if (response.status === "success") {
      toast.success("Empresa actualizada correctamente");
      await saveEmpresa(data.idEmpresa, session().token);
    } else {
      var msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  });

  return (
    <>
      <div className="border-bottom border-translucent mb-5 mx-n3 px-2 mx-lg-n6 px-lg-6">
        <div className="row">
          <div className="col-xl-9">
            <div className="d-sm-flex justify-content-between">
              <h2 className="mb-4">Información de empresa</h2>
              <div className="d-flex mb-3">
                <button
                  className="btn btn-phoenix-primary me-2 px-6 rounded-4"
                  type="button"
                  disabled={true}
                >
                  Cancelar
                </button>
                <button
                  className="btn btn-primary rounded-4"
                  type="button"
                  onClick={() => sendUpdateEmpresa()}
                >
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-9">
          <div className="d-flex align-items-end position-relative mb-5">
            <input
              className="d-none"
              id="upload-avatar"
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleImageChange}
            />
            <div
              className="hoverbox"
              style={{ width: "150px", height: "150px" }}
            >
              <div
                className="hoverbox-content rounded-circle d-flex flex-center z-1"
                style={{ cursor: "pointer", "--phoenix-bg-opacity": 0.56 }}
                onClick={() => fileInputRef.current.click()}
              >
                <span className="fa-solid fa-camera fs-1 text-body-quaternary"></span>
              </div>

              <div className="position-relative bg-body-quaternary rounded-circle cursor-pointer d-flex flex-center mb-xxl-7">
                <div className="avatar avatar-5xl">
                  <img
                    className="rounded-circle"
                    src={
                      previewImg !== imgEmpresa
                        ? previewImg
                        : empresa?.logo && empresa.logo !== ""
                        ? `data:image/jpeg;base64,${empresa.logo}`
                        : imgEmpresa
                    }
                    alt=""
                  />
                </div>
                <label
                  className="w-100 h-100 position-absolute z-1"
                  htmlFor="upload-avatar"
                  style={{ cursor: "pointer" }}
                ></label>
              </div>
            </div>
            <div className="ms-5 mb-6 flex-grow-1">
              <div
                className="alert alert-outline-info d-flex align-items-center py-3 px-3 mb-0 rounded-4"
                role="alert"
              >
                <span className="fas fa-info-circle text-info fs-6 me-2"></span>
                <span className="small mb-0">
                  {empresa?.bloqueo === "S"
                    ? "Esta empresa se encuentra bloqueada, no podrá emitir comprobantes"
                    : "Esta empresa se encuentra activa, puede emitir comprobantes"}
                </span>
              </div>
            </div>
          </div>
          <h4 className="mb-3">Principal </h4>
          <form className="row g-3 mb-9" onSubmit={sendUpdateEmpresa}>
            <div className="col-sm-6 col-md-1 me-4">
              <button
                className="btn btn-primary rounded-4"
                type="button"
                onClick={() => getRucSunat()}
              >
                <span className="fas fa-search fs-6"></span>
              </button>
            </div>
            <div className="col-sm-6 col-md-3">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputFirstname"
                  type="number"
                  placeholder="First name"
                  {...form1.register("ruc", {
                    required: {
                      value: true,
                      message: "El RUC es obligatorio",
                    },
                    maxLength: {
                      value: 11,
                      message: "RUC demasiado largo, máximo 11 caracteres",
                    },
                    minLength: {
                      value: 11,
                      message: "RUC demasiado corto, mínimo 11 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputFirstname">RUC</label>
                {form1.formState.errors?.ruc && (
                  <code>{form1.formState.errors.ruc.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-7">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputCompany"
                  type="text"
                  placeholder="Company"
                  {...form1.register("rSocial", {
                    required: {
                      value: true,
                      message: "La razón social es obligatoria",
                    },
                    maxLength: {
                      value: 255,
                      message:
                        "Razón social demasiado larga, máximo 255 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputCompany">Razon social</label>
                {form1.formState.errors?.rSocial && (
                  <code>{form1.formState.errors.rSocial.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-7">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputTitle"
                  type="text"
                  placeholder="title"
                  {...form1.register("direccion", {
                    required: {
                      value: true,
                      message: "La dirección es obligatoria",
                    },
                    maxLength: {
                      value: 255,
                      message:
                        "Dirección demasiado larga, máximo 255 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputTitle">Dirección</label>
                {form1.formState.errors?.direccion && (
                  <code>{form1.formState.errors.direccion.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-5">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputEmail"
                  type="text"
                  placeholder="email"
                  {...form1.register("correo", {
                    required: {
                      value: true,
                      message: "El correo es obligatorio",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Formato de correo inválido",
                    },
                  })}
                />
                <label htmlFor="floatingInputEmail">Correo</label>
                {form1.formState.errors?.correo && (
                  <code>{form1.formState.errors.correo.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputAlternativeEmail"
                  type="text"
                  placeholder="alternative email"
                  {...form1.register("web", {
                    pattern: {
                      value:
                        /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/,
                      message: "Formato de enlace web inválido",
                    },
                  })}
                />
                <label htmlFor="floatingInputAlternativeEmail">Web link</label>
                {form1.formState.errors?.web && (
                  <code>{form1.formState.errors.web.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputPhone"
                  type="text"
                  placeholder="phone"
                  {...form1.register("telefono1")}
                />
                <label htmlFor="floatingInputPhone">Telefono 1</label>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputWebsite"
                  type="text"
                  placeholder="website"
                  {...form1.register("telefono2")}
                />
                <label htmlFor="floatingInputWebsite">Telefono 2</label>
              </div>
            </div>
            <h4 className="mt-6">Información secundaria</h4>
            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputStreet"
                  type="text"
                  placeholder="street"
                  {...form1.register("pais", {
                    maxLength: {
                      value: 100,
                      message: "País demasiado largo, máximo 100 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputStreet">País</label>
                {form1.formState.errors?.pais && (
                  <code>{form1.formState.errors.pais.message}</code>
                )}
              </div>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputZipcode"
                  type="text"
                  placeholder="zip code"
                  {...form1.register("departamento", {
                    maxLength: {
                      value: 100,
                      message:
                        "Departamento demasiado largo, máximo 100 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputZipcode">Departamento</label>
                {form1.formState.errors?.departamento && (
                  <code>{form1.formState.errors.departamento.message}</code>
                )}
              </div>
            </div>

            <div className="col-sm-6 col-md-4">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputZipcode"
                  type="text"
                  placeholder="zip code"
                  {...form1.register("provincia", {
                    maxLength: {
                      value: 100,
                      message:
                        "Provincia demasiado largo, máximo 100 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputZipcode">Provincia</label>
                {form1.formState.errors?.provincia && (
                  <code>{form1.formState.errors.provincia.message}</code>
                )}
              </div>
            </div>

            <div className="col-sm-6 col-md-4 me-5">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputZipcode"
                  type="text"
                  placeholder="zip code"
                  {...form1.register("distrito", {
                    maxLength: {
                      value: 100,
                      message:
                        "Distrito demasiado largo, máximo 100 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputZipcode">Distrito</label>
                {form1.formState.errors?.distrito && (
                  <code>{form1.formState.errors.distrito.message}</code>
                )}
              </div>
            </div>
            <div className="col-sm-6 col-md-3">
              <div className="form-check form-switch mt-2">
                <input
                  className="form-check-input"
                  id="flexSwitchCheckDefault"
                  type="checkbox"
                  {...form1.register("validarAlmacen")}
                />
                <label
                  className="form-check-label"
                  htmlFor="flexSwitchCheckDefault"
                >
                  Validar almacen
                </label>
              </div>
            </div>
            <div className="col-sm-6 col-md-4">
              <button
                className="btn btn-outline-primary rounded-pill me-1 mb-1 mt-1"
                type="button"
                disabled={true}
              >
                Bloquear empresa
              </button>
            </div>

            <div className="col-sm-6 col-md-12">
              <div className="form-floating">
                <input
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingInputZipcode"
                  type="text"
                  placeholder="zip code"
                  {...form1.register("nombreComercial", {
                    maxLength: {
                      value: 255,
                      message:
                        "Distrito demasiado largo, máximo 255 caracteres",
                    },
                  })}
                />
                <label htmlFor="floatingInputZipcode">Nombre comercial</label>
                {form1.formState.errors?.nombreComercial && (
                  <code>{form1.formState.errors.nombreComercial.message}</code>
                )}
              </div>
            </div>

            <h4 className="mt-6">Observación</h4>
            <div className="col-12">
              <div className="form-floating">
                <textarea
                  className="form-control rounded-4 border-0 shadow-sm"
                  id="floatingProjectOverview"
                  placeholder="Leave a comment here"
                  style={{ height: "128px" }}
                  rows="3"
                  {...form1.register("obs", {
                    maxLength: {
                      value: 500,
                      message: "Observación demasiada larga",
                    },
                  })}
                  defaultValue=""
                ></textarea>
                <label htmlFor="floatingProjectOverview">
                  Escriba su descripción
                </label>
                {form1.formState.errors?.obs && (
                  <code>{form1.formState.errors.obs.message}</code>
                )}
              </div>
            </div>
            <div
              className="col-12 d-flex justify-content-end mt-6"
              type="submit"
            >
              <button className="btn btn-primary rounded-4">Actualizar</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
